import { render, staticRenderFns } from "./ContactGroupList.vue?vue&type=template&id=ae1ecfe6&"
import script from "./ContactGroupList.vue?vue&type=script&lang=js&"
export * from "./ContactGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports